export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  console.log('authHeader, user:', user);
  if (user && user.token) {
    return { Authorization: 'Bearer ' + user.token };
  } else {
    return {};
  }
}